<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header d-flex">
          <div>
            <h4 class="card-header-title">Chỉnh sửa tin tức</h4>
          </div>
        </div>
        <div class="main-body mt-1">
          <div class="main-body-table">
            <el-form
              :model="mData.dataForm"
              :rules="mData.validForm"
              @submit.native.prevent
              ref="formAddNews"
              label-width="160px"
              label-position="top"
            >
              <b-row class="mb-1">
                <b-col md="2" class="pl-0">
                  <el-form-item
                    label="Ảnh bài viết"
                    prop="image"
                    class="time-attendance-photo"
                    ref="image"
                  >
                    <el-image
                      v-if="!loadImage"
                      class="avatar__image"
                      @click="
                        showDetailImage(imgUrl ? imgUrl : 'img/document.jpg')
                      "
                      :src="imgUrl ? imgUrl : 'img/document.jpg'"
                      fit="cover"
                      title="Nhấn vào để xem trước"
                    ></el-image>
                    <el-upload
                      class="upload-demo"
                      action
                      :show-file-list="false"
                      :auto-upload="false"
                      :accept="mData.fileUploadOption.Anh.accept"
                      :on-change="fn_uploadChangeFile"
                      :disabled="
                        !isCreatorOrAdmin ||
                        isApproved ||
                        !mData.dataDefault.listFeature.includes('FT2204')
                      "
                    >
                      <el-button
                        :disabled="
                          !isCreatorOrAdmin ||
                          isApproved ||
                          !mData.dataDefault.listFeature.includes('FT2204')
                        "
                        size="small"
                        class="btn-default"
                      >
                        Tải ảnh lên
                      </el-button>
                    </el-upload>
                  </el-form-item>
                </b-col>

                <b-col md="10" class="p-0">
                  <b-row>
                    <b-col md="4">
                      <el-form-item label="Danh mục tin tức" prop="category_id">
                        <el-select
                          v-model="mData.dataForm.category_id"
                          filterable
                          :disabled="disabledInput"
                        >
                          <el-option
                            v-for="item in listNewsCategory"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Nổi bật" prop="is_important">
                        <el-select
                          v-model="mData.dataForm.is_important"
                          filterable
                          @input="forceUpdateUI"
                          :disabled="isApproved"
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listOutStanding"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <!-- <el-form-item label="Trạng thái bài viết" prop="status">
                        <el-select
                          v-model="mData.dataForm.status"
                          filterable
                          @input="forceUpdateUI"
                          :disabled="
                            (isCreatorOrAdmin &&
                              !mData.dataDefault.listFeature.includes(
                                'FT2203'
                              )) ||
                            isApproved
                          "
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listNewsStatus"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item> -->
                      <div class="new__status">
                        <p class="mr-2 status__block-title">
                          Trạng thái bài viết
                        </p>
                        <div
                          :class="{
                            'content status__block': true,
                            waiting_approver:
                              mData.dataForm.status == 'WAITING_APPROVER',
                            request_edit:
                              mData.dataForm.status == 'REQUEST_EDIT',
                            approver: mData.dataForm.status == 'APPROVERED',
                          }"
                        >
                          {{ NewsListModel.matchStatusName(mData.dataForm.status) }}
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col :md="checkShowNote ? '4' : '12'">
                      <el-form-item label="Tiêu đề bài viết" prop="title">
                        <el-input
                          type="textarea"
                          v-model="mData.dataForm.title"
                          placeholder=""
                          :disabled="disabledInput"
                          resize="none"
                          :rows="3"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="8" v-if="checkShowNote">
                      <el-form-item label="Nội dung cần chỉnh sửa">
                        <p class="note-content">{{ showContent }}</p>
                      </el-form-item>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row>
                <b-col
                  md="12"
                  class="editor_custom pl-0"
                  :key="componentUpdate"
                >
                  <el-form-item label="Nội dung bài viết" prop="content">
                    <ckeditor
                      v-model="mData.dataForm.content"
                      :config="editorConfig"
                      :readOnly="editorConfig.readOnly"
                       editor-url="/ckeditor/ckeditor.js"
                      @blur="fn_checkValid()"
                    ></ckeditor>
                  </el-form-item>
                </b-col>
              </b-row>
              <div class="text-center mt-3">
                <el-button round class="btn-back" @click="fn_goToNewsList()"
                  >Quay lại</el-button
                >
                <el-button
                  round
                  class="btn-default"
                  @click="fn_submitForm('save')"
                  native-type="submit"
                  v-if="isCreatorOrAdmin"
                >
                  Lưu
                </el-button>
                <el-button
                  round
                  class="btn-default"
                  @click="fn_submitForm('browse')"
                  native-type="submit"
                  v-if="isCreatorOrAdmin"
                >
                  Chuyển duyệt
                </el-button>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <el-image-viewer
      class="dialog__image-viewer"
      v-if="visibleDialogImage"
      :on-close="closeViewer"
      :url-list="[imgUrl]"
    />
  </div>
</template>

<script>
import LanguageService from "../../../../service/LanguageService";
import ExtensionService from "../../../../service/ExtensionService";
import ValidService from "../../../../service/ValidService";
import MethodService from "../../../../service/MethodService";
import NewsApi from "../../../../moduleApi/NewsApi";
import NewsCategoryApi from "../../../../moduleApi/NewsCategoryApi";
import NewsListModel from "./NewsListModel";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";

export default {
  components: {
    ElImageViewer,
  },
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      NewsListModel,
      editorConfig: {
        height: 300,
        readOnly: false,
        editorplaceholder: "Nhập nội dung ở đây...",
        extraPlugins: "colorbutton,colordialog,justify,editorplaceholder",
        removeButtons: 'Save,Print,NewPage',
        // The configuration of the editor.
        toolbarGroups: [
          { name: "clipboard", groups: ["undo"] },
          { name: "editing", groups: ["find", "selection", "spellchecker"] },
          { name: "links" },
          { name: "insert" },
          { name: "forms" },
          { name: "tools" },
          { name: "document", groups: ["mode", "document", "doctools"] },
          { name: "others" },
          { name: "basicstyles", groups: ["basicstyles", "cleanup"] },
          {
            name: "paragraph",
            groups: ["list", "indent", "blocks", "align", "bidi"],
          },
          { name: "styles" },
          { name: "colors" },
          { name: "about" },
        ],
      },
      mData: {
        id: null,
        moduleName: "News", //required
        dataForm: MethodService.copyObject(NewsListModel.dataForm),
        validForm: NewsListModel.validForm,
        tableRules: MethodService.copyObject(NewsListModel.tableRules),
        dataDefault: {
          listFeature: MethodService.getListFeatures(),
          listOutStanding: NewsListModel.listOutStanding,
          listNewsStatus: NewsListModel.listNewsStatus,
        },
        currentUser: MethodService.getCurrentUser(),
        currentCompany: MethodService.getCompanyInfo(),
        fileUploadOption: {
          dialogImageUrl: "",
          dialogVisible: false,
          Anh: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: [],
          },
        },
      },
      imgUrl: "",
      loadImage: false,
      visibleDialogImage: false,
      listNewsCategory: [],
      isCreatorOrAdmin: false,
      isCreator: false,
      isApproved: false,
      componentUpdate: 0,
      idCategory: undefined
    }
  },
  computed: {
    disabledInput() {
      return !this.isCreatorOrAdmin || this.isApproved || !this.mData.dataDefault.listFeature.includes('FT2204')
    },
    checkShowNote() {
      return this.mData.dataForm.status == 'REQUEST_EDIT' && this.mData.dataForm.notes.length > 0
    },
    showContent() {
      return this.mData.dataForm.notes[this.mData.dataForm.notes.length - 1].content
    }
  },
  methods: {
    fn_checkValid() {
      if (this.mData.dataForm.content)
        this.$refs["formAddNews"].clearValidate("content");
      else this.$refs["formAddNews"].validateField("content");
    },

    fn_checkAuthor(data) {
      if (
        data.creator_id == this.mData.currentUser.id ||
        this.mData.currentCompany.id == this.mData.currentUser.id
      ) {
        this.isCreatorOrAdmin = true
      }
      if (data.creator_id == this.mData.currentUser.id) this.isCreator = true
    },

    async fn_getListNewsCategory() {
      const newsCategoryApiRes = await NewsCategoryApi.list({
        filters: this.idCategory ?  `disabled=false|id=${this.idCategory}` : `disabled=false`,
        limit: 9999,
      });
      if (newsCategoryApiRes.result) {
        this.listNewsCategory = newsCategoryApiRes.result;
      }
    },

    async fn_uploadChangeFile(file, fileList) {
      if (file && file.name) {
        if (!this.checkTypeImagae(file.name)) {
          window.toastr.warning("Ảnh phải có định dạng là png, jpg hoặc jpeg");
          this.mData.fileUploadOption.Anh.fileList = [];
          return;
        }
      }
      if (MethodService.checkMaxFileSize(file, 10)) {
        window.toastr.warning("Ảnh tải lên có dung lương tối đa không quá 10MB")
        this.mData.fileUploadOption.Anh.fileList = []
        return
      }
      ExtensionService.upload(file, "File_News")
        .then((res) => {
          this.loadImage = true;
          this.mData.dataForm.image = res.result;
          this.imgUrl = ExtensionService.urlImg + res.result;

          this.mData.fileUploadOption.Anh.fileList = fileList;
          this.$refs["formAddNews"].clearValidate("image");
          if (this.mData.dataForm.image) {
            this.mData.validForm.image = [];
          }
          this.loadImage = false;
        })
        .catch((error) => {
          this.loadImage = false;
          this.mData.validForm.image = [ValidService.requiredChange];
          this.$refs["formAddNews"].clearValidate("image");
          window.toastr.error("Có lỗi xảy ra. Vui lòng thử lại");
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },

    checkTypeImagae(fileName) {
      let lastIndexOfDot = fileName.lastIndexOf(".");
      let fileType = fileName.substr(lastIndexOfDot + 1, fileName.length);
      let typeImage = ["png", "jpg", "jpeg"];
      return typeImage.includes(fileType.toLowerCase())
    },

    showDetailImage(url) {
      this.imgUrl = url;
      setTimeout(() => {
        this.visibleDialogImage = true;
      }, 100);
    },

    closeViewer() {
      this.visibleDialogImage = false;
    },

    beforeCloseDialogImage() {
      this.imgUrl = "";
      this.visibleDialogImage = false;
    },

    fn_checkContentReadonly() {
      if (
        !this.mData.dataDefault.listFeature.includes("FT2204") ||
        (!this.isCreatorOrAdmin &&
          this.mData.dataDefault.listFeature.includes("FT2203")) ||
        this.isApproved
      ) {
        this.editorConfig.readOnly = true;
        this.componentUpdate++;
      }
    },

    async fn_getDataById(id) {
      let res = await NewsApi.findById(id);
      if (res.result) {
        if (!res.result.notes) res.result.notes = []
        this.mData.dataForm = res.result;
        this.idCategory = res.result.category_id
        this.imgUrl = ExtensionService.urlImg + res.result.image;
        await this.fn_getListNewsCategory()
        await this.fn_checkAuthor(this.mData.dataForm);
        await this.fn_checkOptionByRole();
        await this.fn_checkContentReadonly();
        await this.fn_checkApprovedNews(this.mData.dataForm.status);
      }
    },

    fn_checkApprovedNews(status) {
      if (status == "APPROVERED" && this.isCreatorOrAdmin) {
        this.isApproved = true;
        window.toastr.warning(
          "Tin tức này đã được duyệt. Bạn không có quyền thao tác trên tin tức này nữa."
        );
        setTimeout(() => {
          this.fn_goToNewsList();
        }, 3500);
      }
    },



    fn_submitForm(type) {
      this.$refs["formAddNews"].validate(async (valid) => {
        if (!valid) return false;
        try {
          // await this.fn_getDataById(this.$route.params.id)
          let data = this.mData.dataForm
          if (!data.content) {
            window.toastr.warning("Vui lòng nhập nội dung bài viết");
            return
          } else {
            data.content = data.content.trim()
          }
          data.title = data.title ? data.title.trim() : ""
          data.id = this.$route.params.id
          data.status = type == 'browse' ? 'WAITING_APPROVER' : data.status
          if (
            this.mData.dataDefault.listFeature.includes("FT2204") &&
            data.status !== "APPROVERED"
          ) {
            await NewsApi.update(data)
            window.toastr.success("Cập nhật thành công")
            await this.fn_goToNewsList()
          }
        } catch (error) {
          window.toastr.error("Cập nhật thất bại");
        }
      });
    },

    fn_resetForm() {
      this.mData.dataForm = MethodService.copyObject(NewsListModel.dataForm);
      this.imgUrl = null;
      this.$refs["formAddNews"].resetFields();
    },

    fn_goToNewsList() {
      this.$router.go(-1);
    },

    fn_checkOptionByRole() {
      if (!this.mData.dataDefault.listFeature.includes("FT2203")) {
        this.mData.dataDefault.listNewsStatus = [
          {
            label: "Chờ duyệt",
            value: "WAITING_APPROVER",
          },
          {
            label: "Yêu cầu chỉnh sửa",
            value: "REQUEST_EDIT",
          },
        ];
      } else {
        this.mData.dataDefault.listNewsStatus = [
          {
            label: "Chờ duyệt",
            value: "WAITING_APPROVER",
          },
          {
            label: "Yêu cầu chỉnh sửa",
            value: "REQUEST_EDIT",
          },
          {
            label: "Đã duyệt",
            value: "APPROVERED",
          },
        ];
      }
    },

    forceUpdateUI() {
      this.$forceUpdate();
    },
  },
  async created() {
    this.mData.validForm.image = [ValidService.requiredChange];
    await this.fn_getDataById(this.$route.params.id);
  },
};
</script>

<style lang="scss" scoped>
.note-content {
  padding: 8px;
  background: #f4f4f5;
  border-radius: 8px;
  color: #4e5055;
  font-size: 14px;
  height: 90px;
  overflow: auto;
}
.fade-enter-active {
  transition: all 0.2s ease;
}
.fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.fade-enter,
.fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
.icon {
  cursor: pointer;
}
::v-deep .isax-setting-2 {
  transition: 0.2s ease;
  &:hover {
    color: var(--orange);
  }
}
::v-deep .el-input-number {
  .el-input__inner {
    text-align: left;
  }
  .el-input-number__decrease,
  .el-input-number__increase {
    border: none;
    background: transparent;
    line-height: 20px !important;
  }
}
::v-deep .content {
  overflow: hidden;
  text-overflow: ellipsis;
}
:v-deep .time-attendance-photo {
  margin-bottom: 15px;
  .el-form-item__content {
    margin-left: 0 !important;
  }
}
.upload-demo {
  margin-top: 10px !important;
  width: fit-content;
  margin: 0 auto;
}
.upload-demo .el-upload .el-button {
  padding: 5px 23px;
  border-radius: 5px !important;
}
.avatar__image {
  max-width: 100%;
  height: 120px;
  left: 50%;
  transform: translateX(-50%);
  :hover {
    cursor: pointer;
  }
}
.icon24-Stamp {
  font-size: inherit;
}

::v-deep .editor_custom {
  .ql-editor {
    background-color: #fff;
  }
  .ql-picker {
    margin-top: -11px;
  }
  .ql-color-picker,
  .ql-align {
    margin-top: -15px;
  }
  .ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {
    margin-top: -3px;
  }
}
.cursor-notAllow {
  cursor: not-allowed !important;
}
::v-deep .hide-toolbar {
  .ql-toolbar {
    padding: 0;
    border-bottom: hidden;
    span {
      display: none;
    }
  }
  .ql-editor {
    cursor: not-allowed;
  }
}
.new__status {
  font-size: 15px;
  .status__block-title {
    font-size: 15px;
    margin-bottom: 13px;
  }
  .status__block {
    font-family: "UTM Avo";
    width: fit-content;
    padding: 10px 15px;
    border-radius: 8px;
    box-shadow: 0px 0px 10px rgb(0, 0, 0, 0.1);
  }
  .waiting_approver {
    color: #3db82b;
    background: #cef1c2;
  }
  .request_edit {
    color: #ff8800;
    background: #ffc31d4b;
  }
  .approver {
    color: white;
    background: #6bc457;
  }
}
</style>
<style>
.cke_notification_warning {
  display: none !important;
}
</style>